/**
 * This component is rendered only once on app start. It has access to all
 * common Context APIs like Redux and Apollo.
 */

import { useEffect } from 'react';

import useLocation from '@skippay/core/hooks/useLocation';

import {
	promoSourceFromQuery,
	storePreferredPromoSourceToCookie,
	storePromoSourceToCookie,
} from 'utils/promoUtils';

import useExperimentalFnFFeaturesToggle from './useExperimentalFnFFeaturesToggle';

function OnLoadActions() {
	const {
		location: { query },
	} = useLocation();

	useExperimentalFnFFeaturesToggle();

	useEffect(() => {
		const promoSource = promoSourceFromQuery(query);
		if (promoSource) {
			storePromoSourceToCookie(promoSource);
			storePreferredPromoSourceToCookie(promoSource);
		}
	}, []);

	return null;
}

export default OnLoadActions;
